<template>
  <DrawerV2 v-model="visible" size="90%">
    <!-- 左侧：头像（点击不关闭） -->
    <template #header-left>
      <img alt="AI" class="ai-recommend-task-drawer__avatar" :src="avatarImg" @click.stop />
    </template>

    <!-- 居中标题区域：标题 + 副标题 -->
    <template #title>
      <div class="ai-recommend-task-drawer__header-text">
        <div class="ai-recommend-task-drawer__title">
          {{ mainTitle }}
        </div>
        <div class="ai-recommend-task-drawer__subtitle">{{ subtitle }}</div>
      </div>
    </template>

    <!-- 右侧：关闭按钮 -->
    <template #header-right>
      <i
        class="ai-recommend-task-drawer__close icon-close-line t-iconfont"
        @click="visible = false"
      ></i>
    </template>

    <!-- 主体：空状态 -->
    <div class="ai-recommend-task-drawer__body">
      <div v-loading="orderLoading" class="tab-box">
        <OrderAnalysis
          v-if="!orderLoading"
          ref="orderAnalysisRef"
          :deatil-data="deatilData"
          :detail-type="detailType"
          is-app
          :sale-order-data="saleOrderData"
          @refresh="handleRefresh"
          @success="handleSuccess"
        ></OrderAnalysis>
      </div>
    </div>
  </DrawerV2>
</template>

<script setup>
import { computed, watch, ref } from 'vue'
import DrawerV2 from '@/components/drawer-mobile/drawer-v2.vue'
import avatarImg from '@/assets/ai-avatar/ai-avatar-2x-9.png'
import OrderAnalysis from '@/pages/ai-board/components/components/ai-detail-dialog/components/order-analysis.vue'
import { getResult } from '@/api/ai-detail.js'

defineOptions({ name: 'SaleAnalysDrawer' })

const visible = defineModel({ type: Boolean, default: false })
const props = defineProps({
  businessType: {
    type: Number,
    default: 100
  },
  dataId: {
    type: [String, Number],
    default: ''
  }
})

const detailType = computed(() => {
  const enumMap = {
    100: 'customer',
    8000: 'clue'
  }
  return enumMap[props.businessType]
})

const mainTitle = computed(() => {
  const title = orderAnalysisRef.value?.showTitle
  return title || 'AI 分析师随时准备为你分析'
})

const subtitle = computed(() => {
  const desc = orderAnalysisRef.value?.showDesc || 'AI 帮你复盘客户'
  return desc
})

watch(visible, (newVal) => {
  if (newVal) {
    initData()
  }
})

const orderAnalysisRef = ref(null)
const orderLoading = ref(false)
const deatilData = ref({})
const saleOrderData = ref({})
const initData = async () => {
  const params = {}
  if (props.businessType === 8000) {
    params.clueId = props.dataId
    deatilData.value = {
      clueId: props.dataId
    }
  } else {
    params.customerId = props.dataId
    deatilData.value = {
      customerId: props.dataId
    }
  }
  try {
    const res = await getResult(params)
    saleOrderData.value = res.result
  } catch (error) {
    console.error('获取分析结果失败:', error)
  }
  orderLoading.value = false
}

const handleSuccess = (data) => {
  console.log('分析成功回调:', data)
  initData()
}

const handleRefresh = () => {
  initData()
}
</script>

<style lang="scss" scoped>
.ai-recommend-task-drawer {
  &__avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
    margin-right: 12px;
  }

  &__header-text {
    display: flex;
    flex-direction: column;
    text-align: left;
  }

  &__title {
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
    color: #323233;
  }

  &__subtitle {
    margin-top: 2px;
    font-size: 13px;
    line-height: 18px;
    color: #969799;
  }

  &__close {
    font-size: 20px;
    color: #c9cdd4;
    cursor: pointer;
  }

  &__body {
    display: flex;
    height: 100%;
    position: relative;
    overflow: hidden;
    .tab-box {
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow-y: auto;
      background: #f3f3f3;
    }
  }
}
</style>
